import React, { useState } from "react";
import classes from "./PaymentSuccess.module.css";
import { useTranslation } from "react-i18next";
// import Button from "@mui/material/Button";
// import TextField from "@mui/material/TextField";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Seo, Avatar, InvoiceCardBanner } from "@components";
// import Logo from "@assets/img/logo.png";
import { FormFeedback } from "reactstrap";
import axiosInstance from "@store/interceptor/axiosInstance";
import Correct from "@assets/img/correct.png";

/** Redux **/
import { onAuthenticate, onGetData } from "@store/pendingInvoices";
import { useDispatch, useSelector } from "react-redux";

/** Third Party **/
import { Config } from "@config/config";
import { NavLink, useNavigate, Navigate } from "react-router-dom";

export const PaymentSuccess = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  return (
    <>
      <Seo title={`${Config.name} | ${t("paymentSuccess")}`} />
      <div className={`${classes.block}`}>
        <div className={`${classes.boxContainer}`}>
          <div className={`${classes.box} mb-3`}>
            <div className={`${classes.preview} text-center`}>
              <Avatar src={Correct} className={`${classes.imgCorrect}`} />
              <div className={`${classes.title} pt-3`}>Payment Complete</div>
              <div className={`${classes.text} pt-1`}>
                Your payment has been recieved.
              </div>
            </div>

            <div className={`${classes.company} d-flex align-items-center`}>
              <Avatar
                src={Config?.logo?.default}
                className={`${classes.companyImg}`}
              />
              <div className={`${classes.title}`}>ALOSAIMI PEARL</div>
            </div>

            <div className={`${classes.body}`}>
              <div className={`${classes.grid}`}>
                <div className={`${classes.gridCard}`}>
                  <span
                    className={`icon-credit-card-success ${classes.icon}`}></span>
                  <div className={`${classes.cardTitle}`}>380.00 KWD</div>
                </div>

                <div className={`${classes.gridCard}`}>
                  <span
                    className={`icon-calendar ${classes.icon} ${classes.iconCalendar}`}></span>
                  <div className={`${classes.cardTitle}`}>08-06-2024</div>
                </div>

                <div className={`${classes.gridCard}`}>
                  <span className={`icon-bar-code ${classes.icon}`}></span>
                  <div className={`${classes.cardTitle}`}>2PM-21</div>
                </div>
              </div>

              <div className={`${classes.tableContainer} pt-4`}>
                <div className={`${classes.table}`}>
                  <div className={`${classes.row}`}>
                    <div className={`${classes.cell}`}>Status</div>
                    <div className={`${classes.cell} ${classes.successed}`}>
                      Paid
                    </div>
                  </div>
                  <div className={`${classes.row}`}>
                    <div className={`${classes.cell}`}>Subject</div>
                    <div className={`${classes.cell}`}>Rent</div>
                  </div>
                  <div className={`${classes.row}`}>
                    <div className={`${classes.cell}`}>Client Name</div>
                    <div className={`${classes.cell}`}>Mohamed Kamal</div>
                  </div>
                  <div className={`${classes.row}`}>
                    <div className={`${classes.cell}`}>Civil ID</div>
                    <div className={`${classes.cell}`}>47872148</div>
                  </div>
                  <div className={`${classes.row}`}>
                    <div className={`${classes.cell}`}>Phone No</div>
                    <div className={`${classes.cell}`}>+96569063504</div>
                  </div>
                  <div className={`${classes.row}`}>
                    <div className={`${classes.cell}`}>Email</div>
                    <div className={`${classes.cell}`}>
                      mohamed_kamal@gmail.com
                    </div>
                  </div>
                  <div className={`${classes.row}`}>
                    <div className={`${classes.cell}`}>Notes</div>
                    <div className={`${classes.cell}`}>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Maxime mollitia, molestiae quas vel
                    </div>
                  </div>
                  {/* <div className={`${classes.row}`}>
                    <div className={`${classes.cell}`}>Process Number</div>
                    <div className={`${classes.cell}`}>422413003858201</div>
                  </div> */}
                  {/* <div className={`${classes.row}`}>
                    <div className={`${classes.cell}`}>Payment Method</div>
                    <div className={`${classes.cell}`}>Knet</div>
                  </div> */}
                  {/* <div className={`${classes.row}`}>
                    <div className={`${classes.cell}`}>Payment Date</div>
                    <div className={`${classes.cell}`}>11-08-2024</div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className={`${classes.box} ${classes.boxPadding} mb-2`}>
            <div className={`${classes.subTitle}`}>Invoice Details</div>
            <div className={`${classes.normalList} mb-3`}>
              <div className={`${classes.nlRow}`}>
                <div className={`${classes.nlRowKey}`}>Receipt Number</div>
                <div className={`${classes.nlRowValue}`}>2783-3292</div>
              </div>

              <div className={`${classes.nlRow}`}>
                <div className={`${classes.nlRowKey}`}>Invoice Number</div>
                <div className={`${classes.nlRowValue}`}>367D07B2-0016</div>
              </div>

              <div className={`${classes.nlRow}`}>
                <div className={`${classes.nlRowKey}`}>Transaction ID</div>
                <div className={`${classes.nlRowValue}`}>8984BE452KO47</div>
              </div>

              <div className={`${classes.nlRow}`}>
                <div className={`${classes.nlRowKey}`}>Reference ID</div>
                <div className={`${classes.nlRowValue}`}>9946751</div>
              </div>

              <div className={`${classes.nlRow}`}>
                <div className={`${classes.nlRowKey}`}>Payment Method</div>
                <div className={`${classes.nlRowValue}`}>Knet - 7658**</div>
              </div>
              <div className={`${classes.nlRow}`}>
                <div className={`${classes.nlRowKey}`}>Payment Date</div>
                <div className={`${classes.nlRowValue}`}>11-08-2024</div>
              </div>
            </div>

            <div className={`${classes.badgeContainer}`}>
              <div className={`${classes.badgeKey}`}>Total Amount Paid</div>
              <div className={`${classes.badgeValue}`}>500.00 KWD</div>
            </div>
          </div>

          <div
            className={`${classes.footer} d-flex align-items-center justify-content-between`}>
            <div className={`${classes.questions}`}>
              Questions? Contact us at{" "}
              <a
                className={`${classes.quesMail}`}
                href="mailto:info@2payme.com"
                target="_blank"
                rel="noreferrer">
                info@2payme.com
              </a>
            </div>

            <NavLink
              className={`btn btn-primary ${classes.actionBtn}`}
              to={"/"}>
              <span class={`icon-chevron-left icon ${classes.icon}`}></span>
              {t("back-to-home")}
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
};
